import { Competition } from '@brg/api';

/** На бэке ключ с кириллической «А»: maxLimitАttemptsPerUser */
export const MAX_LIMIT_ATTEMPTS_PER_USER_KEY = 'maxLimit\u0410ttemptsPerUser';

export const getMaxLimitAttemptsPerUser = (competition?: Competition | null): number | undefined => {
  if (!competition) {
    return undefined;
  }

  // @ts-ignore
  const value = competition[MAX_LIMIT_ATTEMPTS_PER_USER_KEY];

  return typeof value === 'number' && value >= 1 ? value : undefined;
};
import { Competition } from '@brg/api';

/** На бэке ключ с кириллической «А»: maxLimitАttemptsPerUser */
export const MAX_LIMIT_ATTEMPTS_PER_USER_KEY = 'maxLimit\u0410ttemptsPerUser';

export const getMaxLimitAttemptsPerUser = (competition?: Competition | null): number | undefined => {
  if (!competition) {
    return undefined;
  }

  // @ts-ignore
  const value = competition[MAX_LIMIT_ATTEMPTS_PER_USER_KEY];

  return typeof value === 'number' && value >= 1 ? value : undefined;
};
